// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__31UDv","label__name":"Label_label__name__2nmvP","label__active":"Label_label__active__2Q4Pi","label__value":"Label_label__value__2VOdG"};